import { useState } from 'react';
import InputForm from '../../InputT';
import SearInputM from '../../SearchModal';
import { useTranslation } from 'react-i18next';
import ParamsPicklist from '../../../Types/ParamsPicklist';
import DataType from '../../../Types/DataTablePiclist';
import { Box } from '@mui/material';
import SearchInput from '../../SearchInput';

const Swal = require('sweetalert2');
let Link = require('../../../Data/Data.json');

let searchClient: ParamsPicklist = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: '',colfiltre:"TYPCLI",valfiltre:'I' ,Choix: 22 }
// let searchGestionnaire: ParamsPicklist = { CodeAgence: '', Table: "GESTIONNAIRE", Colonne1: "CODGES", Colonne2: "LIBELLE", Colagence: '001', Choix: 22 }
// let searchPlanComptable: ParamsPicklist = {Table: "plancp", Colonne1: "idplan", Colonne2: "LIBELL",colfiltre:"categocpt", Choix: 22 }

const Tab1 = (props: { etatG?: boolean, form?: any }) => {

  const datas: DataType[] = [];
  //const {t,i18n}=useTranslation();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
   
  let informationclient = {
    SearchClient: {
      Titre: "Recherche indice GL",
      label: "Indice GL",
      name: "NUMCLI", params: searchClient
    },
  
    InputInstitule: {
      label: "Intitulé GL",
      name: "NOMCLI"
    }
  ,
  
  }


  return (

    <div className='tabItem' >
      <Box display={'flex'} className='border' width={"85%"} position={"absolute"} >
        <Box fontStyle="inherit" className='border-left' width={"50%"}>
          <SearchInput notremove 
          dissabledCode={false}
            // dissabledCode={props.etatG}
            Titre={informationclient.SearchClient.Titre} label={informationclient.SearchClient.label} name={informationclient.SearchClient.name} Parametre={informationclient.SearchClient.params} form={props.form} />
          {/* <SearInputM notRequired Titre={informationclient.searchPlanComptable.Titre} label={informationclient.searchPlanComptable.label} name={informationclient.searchPlanComptable.name} Parametre={informationclient.searchPlanComptable.params} form={props.form} /> */}
        </Box>
        <Box fontStyle="inherit" className='border-left' width={"50%"}>
          <InputForm  width={7} label={informationclient.InputInstitule.label} name={informationclient.InputInstitule.name} type='text' />
        </Box>
      </Box>
    </div>
  
  );
}

export default Tab1;
